import { render, staticRenderFns } from "./TopicPool.vue?vue&type=template&id=59f4cb73&scoped=true&"
import script from "./TopicPool.vue?vue&type=script&lang=js&"
export * from "./TopicPool.vue?vue&type=script&lang=js&"
import style0 from "./TopicPool.vue?vue&type=style&index=0&id=59f4cb73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f4cb73",
  null
  
)

export default component.exports